import React from 'react'
import StockRegisterEdit from '../../components/stockregistercomponents/StockRegisterEdit';

function StockRegisterEditPage() {
    return (
        <>

            {/*Dynamic content goes here */}
            <StockRegisterEdit />

        </>
    )
}

export default StockRegisterEditPage;